var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause17 = function SvgIconPause17(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M47.39 53H5.611A5.61 5.61 0 0 1 0 47.39V5.61A5.61 5.61 0 0 1 5.611 0H47.39A5.61 5.61 0 0 1 53 5.61v41.78A5.61 5.61 0 0 1 47.39 53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M20 33h5V20h-5zm8 0h5V20h-5z"
  }))));
};
export default SvgIconPause17;